import { BACKEND_URL } from "../constants";
import { IWhitelist } from "../types/IWhitelist";

export const getHistoricalNfts = async () => {
    //console.log('getHistoricalNfts', token);
    try {
        const baseUrl = `${BACKEND_URL}/historical-nfts`;
        const res = await fetch(baseUrl, { method: "GET" });
        const json = await res.json();
        //console.log('json', json);
        if (json) {
            return json;
        }
    } catch (err) {
        console.log('getWhitelist err', err)
    }
}
export const getHistoricalNftsForWallet = async (address: string, token: string): Promise<any> => {
    //console.log('getHistoricalNftsForWallet', address, token);
    try {
        const baseUrl = `${BACKEND_URL}/historical-nfts`;
        const res = await fetch(baseUrl, {
            method: "POST",
            body: JSON.stringify({ address: address, token: token.replace('#', '') }),
            headers: {
                'Content-Type': 'application/json'
            },
        });
        const json = await res.json();
        if (json) {
            return json;
        }
    } catch (err) {
        console.log('getWhitelist err', err)
    }
}


export const signUpForWhitelist = async (user: IWhitelist) => {
    try {
        const baseUrl = `${BACKEND_URL}/signup`;
        const whitelister: IWhitelist = {
            gamePassCode: user.gamePassCode,
            discord: user.discord,
            wallet: user.wallet,
            email: user.email,
            origin: user.origin
        }
        const res = await fetch(baseUrl, {
            method: "POST",
            body: JSON.stringify(whitelister),
            headers: {
                'Content-Type': 'application/json'
            },
        });
        const json = await res.json();
        if (json) {
            return json;
        }
    } catch (err) {

    }
}

export const checkAddressOnWhitelist = async (address: string | null) => {
    if (address) {
        //console.log('checkAddressOnWhitelist', address);
        try {
            const baseUrl = `${BACKEND_URL}/checkaddress/${address}`;
            const res = await fetch(baseUrl, { method: "GET" });
            const json = await res.json();
            if (json) {
                return json;
            }
        } catch (err) {

        }
    }
}